// Credit to Liam Egan, @neuromantic6 and his https://github.com/liamegan/fxhash-helpers

const frand_rng = function (min = 0, max = 1) {
  let result = $fx.rand() * (max - min) + min;
  return Math.floor(result * 10000) / 10000;
};

const frand_rng_int = function (min = 0, max = 1) {
  let result = $fx.rand() * (max + 1 - min) + min;
  return Math.floor(result);
};

// const arr_pick = (arr) => arr[Math.floor($fx.rand() * arr.length)];
// bias_fact @ 0 = NaN
// bias_fact @ .1 = picks close to end of array
// bias_fact @ 1 = no bias
// bias_fact >1  = picks closer to start of array

const arr_pick = function (arr, bias_fact = 1) {
  const pick_idx = Math.floor(lerp(0, arr.length, $fx.rand(), bias_fact));
  return arr[pick_idx];
};

const fib_num = function (fib_idx, n0 = 2, n1 = 1) {
  let next_num = 0;
  for (let i = 0; i <= fib_idx; i++) {
    next_num = n0 + n1;
    n0 = n1;
    n1 = next_num;
  }
  return next_num;
};

const lerp = function (start, stop, amt, bias_fact = 1) {
  // amt is a # from 0-1
  // bias_fact values are expected to be between 0-1,
  // negative numbers generate out of bounds values.
  return Math.pow(amt, bias_fact) * (stop - start) + start;
};

const fx_shuffle_arr = function (arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(frand_rng() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
};

// http://opensourcehacker.com/2011/12/01/calculate-aspect-ratio-conserving-resize-for-images-in-javascript/
/**
 * Resize arbitary width x height region to fit inside another region.
 *
 * Conserve aspect ratio of the orignal region. Useful when shrinking/enlarging
 * images to fit into a certain area.
 *
 * @param {Number} srcWidth Source area width 1.412
 *
 * @param {Number} srcHeight Source area height 1
 *
 * @param {Number} maxWidth Fittable area maximum available width 800
 *
 * @param {Number} maxHeight Fittable area maximum available height 600
 *
 * @return {Object} { width, heigth }
 *
 */
const calculateAspectRatioFit = function (
  srcWidth,
  srcHeight,
  maxWidth,
  maxHeight
) {
  var ratio = [maxWidth / srcWidth, maxHeight / srcHeight];
  ratio = Math.min(ratio[0], ratio[1]);

  return { x: srcWidth * ratio, y: srcHeight * ratio };
};

const clamp = function (val, min, max) {
  return val > max ? max : val < min ? min : val;
};

const get_datetime_str = function () {
  const dt = new Date(); // convert this to UTC?
  const datetime = `${dt.getFullYear().toString()}${(dt.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${dt.getDate().toString().padStart(2, "0")}${dt
    .getHours()
    .toString()
    .padStart(2, "0")}${dt.getMinutes().toString().padStart(2, "0")}${dt
    .getSeconds()
    .toString()
    .padStart(2, "0")}${dt.getMilliseconds().toString().padStart(3, "0")}`;
  return datetime;
};
// generate date string: YYYY-MM-DD-HH-MM-SS

export {
  frand_rng,
  frand_rng_int,
  lerp,
  arr_pick,
  fib_num,
  fx_shuffle_arr,
  calculateAspectRatioFit,
  clamp,
  get_datetime_str,
};
